import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";

import NotificationItem from "./NotificationItem";
import type { NotificationsListProps } from "../../types";

const NotificationsList = ({
  items,
  hasMore,
  onLoadMore,
  onRefresh,
}: NotificationsListProps) => {
  const { t } = useTranslation();

  return (
    <InfiniteScroll
      dataLength={items.length}
      next={onLoadMore}
      hasMore={hasMore}
      loader={<div className="loader">{t("notifications.labels.loading")}</div>}
      scrollableTarget="notifications-scroll-container"
      pullDownToRefresh
      pullDownToRefreshThreshold={50}
      refreshFunction={onRefresh}
      pullDownToRefreshContent={
        <div className="notifications-refresh-hint">
          &#8595; {t("notifications.labels.pullToRefresh")}
        </div>
      }
      releaseToRefreshContent={
        <div className="notifications-refresh-hint">
          &#8593; {t("notifications.labels.releaseToRefresh")}
        </div>
      }
    >
      {items.map((item) => (
        <NotificationItem
          key={item.id}
          notification={item}
          className="notifications-list-item"
        />
      ))}
    </InfiniteScroll>
  );
};

export default NotificationsList;
